import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'pollExpired' })
export class PollExpiredPipe implements PipeTransform {
  transform(value: string): boolean {
    const secDiff = moment
      .utc(value)
      .local()
      .diff(moment(), 'seconds');
    return secDiff < 15;
  }
}
